import { useState } from "react";
import { useDispatch } from "react-redux";
import { Typography } from "@mui/material";
import DialogContainer from "../../../../components/dialog-container/dialog-container";
import TextInput from "../../../../components/textinput/textinput";
import { useFormik } from "formik";
import * as yup from "yup";
import { updateRole } from "../../../../utils/APICalls";
import { roleRequest } from "../../../../redux/roles/slice";
import { userType } from "../../../../utils/Constant";
import Loading from "../../../../components/loading/loading";

type props = {
  showDialog: boolean;
  closeDialog: any;
  data?: any;
  roleType: string;
  onSave?: any;
};

interface FormValues {
  name?: string;
}

const ValidationSchema = yup.object({
  name: yup.string().required("This field can't be empty"),
});

export default function EditRole({
  showDialog,
  closeDialog,
  data,
  roleType,
  onSave,
}: props) {
  const [showLoader, setShowLoader] = useState(false);

  const dispatch = useDispatch();

  const formik = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      name: data?.name || "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (value) => {
      updateRoleName(value);
    },
  });

  const updateRoleName = async (payload: any) => {
    setShowLoader(true);
    const response = await updateRole({ ...payload, id: data?.id });
    setShowLoader(false);
    if (response?.status === 204) {
      if (roleType === "Internal") {
        dispatch(roleRequest(userType.tenant));
      } else if (roleType === "Client") {
        dispatch(roleRequest(userType.client));
      } else if (roleType === "Inspection Firm") {
        dispatch(roleRequest(userType.inspector));
      }
      onSave();
      closeDialog();
    }
  };

  return (
    <DialogContainer
      closeDialog={closeDialog}
      showDialog={showDialog}
      title={`Edit ${roleType} Role Name`}
      onSubmit={formik.handleSubmit}
    >
      <form onSubmit={formik.handleSubmit} className="add-role-layout">
        <Typography className="add-role-label-txt">Role Name</Typography>
        <TextInput
          className="field-input"
          id="name"
          name="name"
          label="Role Name"
          variant="outlined"
          placeholder="{Name}"
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
      </form>
      {showLoader && <Loading />}
    </DialogContainer>
  );
}
